export default "__VITE_ASSET__BvpomvCv__"